import React from 'react';
import { connect, ConnectedProps } from 'react-redux';

import lang from '../../lib/language';
import { RootState } from '../../lib/store';

import FilterDropDown from '../../containers/TopGainersAndLosers/components/FilterDropDown/FilterDropDown';
import { useIsMobile } from '../../hooks';
import NavButtons from '../NavigationButtons/NavButtons';
import { NewBaseTable } from '..';

import styles from './DiscoverInternalTable.module.scss';

type ReduxProps = ConnectedProps<typeof connector>;

type Props = {
    hasSecondTable?: boolean;
    tableNames?: Array<string>;
    tableHeaders?: Array<string>;
    onTabChange?: (index: number) => void;
    dropdownOptionValue?: string;
    handleFilterOption?: (option: number[], valueOption: string) => void;
    isLoading?: boolean;
    renderList: JSX.Element | JSX.Element[];
    fullWidthButtons?: boolean;
    hasViewMoreButton?: boolean;
    onViewMoreClick?: () => void;
    isViewMoreDisabled?: boolean;
    initialActiveTab?: number;
}

const DiscoverInternalTable = (props: Props & ReduxProps) => {
  const {
    hasSecondTable,
    tableNames,
    tableHeaders,
    onTabChange,
    isLoading,
    dropdownOptionValue,
    handleFilterOption,
    renderList,
    fullWidthButtons,
    hasViewMoreButton,
    onViewMoreClick,
    isViewMoreDisabled,
    initialActiveTab = 0,
  } = props;

  const isMobile = useIsMobile();

  const tabs = [
    {
      text: tableNames ? tableNames[0] : '',
      component: <></>,
    },
    {
      text: tableNames ? tableNames[1] : '',
      component: <></>,
    },
  ];

  return (
    <div className={styles.wrapper}>
      <div className={styles.buttons}>
        {hasSecondTable
          && (
          <NavButtons
            fullWidthButtons={fullWidthButtons}
            tabs={tabs}
            sendCurrentTabIndex={onTabChange}
            initialActiveTab={initialActiveTab}
          />
          )}
        {dropdownOptionValue && handleFilterOption && (
          <div className={styles.selector}>
            <FilterDropDown
              isDiscover
              isDisabled={isLoading}
              optionValue={dropdownOptionValue}
              handleFilterOption={handleFilterOption}
              hasBackground
              hasExpandArrow
              isElliptic
            />
          </div>
        )}
      </div>
      <div className={styles.tableWrapper}>
        {!isMobile && tableHeaders && (
          <div className={styles.table}>
            <thead>
              {tableHeaders.map((header: string, index: number) =>
                <th className={styles.header} key={header}>{header}</th>)}
            </thead>
          </div>
        )}
        <NewBaseTable>
          <tbody>
            {renderList}
          </tbody>
        </NewBaseTable>
        {hasViewMoreButton && (
          <div className={styles.viewMoreButtonWrapper}>
            <button
              type="button"
              onClick={onViewMoreClick}
              className={styles.viewMoreButton}
              disabled={isViewMoreDisabled}
            >
              {lang.commonLoadMore()}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  companyLogoAndName: state.fundamental.companyLogoAndName,
});

const connector = connect(mapStateToProps);

export default connector(DiscoverInternalTable);
